const DEFAULT_MESSAGE = 'Unable to find document or window for node';

export class BrowsingContextError extends Error {
  constructor(message = DEFAULT_MESSAGE) {
    super(message);
  }
}
